import { ZoneFeature } from "../../models/zones-base-interfaces";
import { ZonesUtilitiesBase } from "./zones-utilities-base";
import { EcaSecaModel } from "../../models/eca-seca-zones-model";

export class EcaSecaAreasUtilities extends ZonesUtilitiesBase {
    zoneID: string = "ECA/SECA"
    zoneStoreType: string = "ECA"
    
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await EcaSecaModel!.getEcaSecaZones();
        if (!zones) {
            throw new Error("Could not retreive ECA/SECA areas.");
        }

        return zones;
    }
}